//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'
import CountrySelectorComponent from '../conditional-components/country-selector-component'

//// Carbon Components
import { TextInput, DatePicker, DatePickerInput, Button } from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalEducationHistoryComponent = ({
    number,
    handleData,
    handleSubtractAdditionalEducationHistoryComponent,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <h4>Additional Education:</h4>

            <TextInput
                className={''}
                labelText="School Name:"
                id={'INST_NME' + number}
                name={'INST_NME' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['INST_NME' + number]}
                maxLength="40"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.['INST_NME' + number]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'INST_NME' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className="required"
                labelText="School Address:"
                id={'SchlAddrOne' + number}
                name={'SchlAddrOne' + number}
                placeholder=""
                value={
                    formsData?.[digital_name]?.values?.['SchlAddrOne' + number]
                }
                maxLength="30"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.['SchlAddrOne' + number]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'SchlAddrOne' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className=""
                labelText=""
                id={'SchlAddrTwo' + number}
                name={'SchlAddrTwo' + number}
                placeholder=""
                value={
                    formsData?.[digital_name]?.values?.['SchlAddrTwo' + number]
                }
                maxLength="30"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.['SchlAddrTwo' + number]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'SchlAddrTwo' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className=""
                labelText=""
                id={'SchlAddrThree' + number}
                name={'SchlAddrThree' + number}
                placeholder=""
                value={
                    formsData?.[digital_name]?.values?.[
                        'SchlAddrThree' + number
                    ]
                }
                maxLength="40"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.[
                        'SchlAddrThree' + number
                    ]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'SchlAddrThree' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className="required"
                labelText="ZIP Code:"
                id={'ZIP' + number}
                name={'ZIP' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['ZIP' + number]}
                maxLength="10"
                type="text"
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.['ZIP' + number]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'ZIP' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className="required"
                labelText="City:"
                id={'CITY' + number}
                name={'CITY' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['CITY' + number]}
                maxLength="10"
                type="text"
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.['CITY' + number]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'CITY' + number + 'ErrMsg'
                    ]
                }
            />

            <CountrySelectorComponent
                digital_name={digital_name}
                value_key={['COUNTRY' + number]}
                state_value_key={['STATE' + number]}
                county_value_key=""
            />

            <StateSelectorComponent
                digital_name={digital_name}
                value_key={['STATE' + number]}
                country={
                    formsData?.[settingsData?.['form']?.['digital_name']]
                        ?.values?.['COUNTRY' + number]
                }
            />

            <DatePicker
                dateFormat="m/d/Y"
                datePickerType="single"
                onChange={(e) => handleData(e, ['GRDT' + number])}
                onClose={(e) => handleData(e, ['GRDT' + number])}
                value={formsData?.[digital_name]?.values?.['GRDT' + number]}
            >
                <DatePickerInput
                    className="required"
                    labelText="Graduation Date:"
                    id={'GRDT' + number}
                    name={'GRDT' + number}
                    placeholder="MM/DD/YYYY"
                    type="text"
                    invalid={
                        formsData?.[digital_name]?.errors?.['GRDT' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'GRDT' + number + 'ErrMsg'
                        ]
                    }
                />
            </DatePicker>

            <TextInput
                className="required"
                labelText="Degree Awarded (Diploma, LPN, ADN, BSN):"
                id={'DGCR' + number}
                name={'DGCR' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['DGCR' + number]}
                maxLength="10"
                type="text"
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.['DGCR' + number]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'DGCR' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className="required"
                labelText="What name(s) did you use when you received your nursing education?"
                id={'EDU_NME' + number}
                name={'EDU_NME' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['EDU_NME' + number]}
                maxLength="10"
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.['EDU_NME' + number]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'EDU_NME' + number + 'ErrMsg'
                    ]
                }
            />

            <div className="half-width-button-with-icon-group">
                <div className="half-width-button-with-icon-group-item">
                    <Button
                        className="fldoh-btn"
                        name={number}
                        type="button"
                        kind="danger"
                        size="md"
                        onClick={
                            handleSubtractAdditionalEducationHistoryComponent
                        }
                    >
                        Remove
                        <Subtract />
                    </Button>
                </div>
            </div>
        </>
    )
}

export default AdditionalEducationHistoryComponent
